import { HttpClient } from '@opallabs/api'
import loadSlide from '../loadSlide'

const patchSlide = (presentationId, slideId, params) =>
  HttpClient().patch(
    `/api/v1/presentations/${presentationId}/canvas_slides/${slideId}`,
    params
  )

const updateSlide = (presentationId, slideId, params) => (dispatch) =>
  patchSlide(presentationId, slideId, params)
    .then((response) => dispatch(loadSlide(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })

export default updateSlide
